import Stack from '@mui/system/Stack/Stack';
import { mapCountry, mapProjectSize } from 'tdc-web-backend/enums/enums';
import BaseInputLabel from '../../../../components/custom-inputs/BaseInputLabel';
import ControlledTextEditor from '../../../../components/custom-inputs/ControlledTextEditor';
import { TimedProjectEditorMenu } from '../../../../components/editor/menu-option-lists/menu-item-lists';
import { secondaryBlue } from '../../../../utils/color';

import CustomInput from '../../../../components/custom-input/CustomInput';
import ControlledTextInput from '../../../../components/custom-inputs/ControlledTextInput';
import useAuth from '../../../../utils/hooks/useAuth';
import { useTranslation } from 'react-i18next';

const BORDER = `1px solid ${secondaryBlue[100]}`;

const Overview = () => {
  const { t } = useTranslation();
  const {
    authData: { userData: user },
  } = useAuth();

  return (
    <Stack spacing={3}>
      <BaseInputLabel text="company overview" />
      <Stack flexDirection="row" sx={{ margin: '0 0 32px 0' }}>
        <Stack spacing={3} flex={1} sx={{ padding: '0 24px 0 0', borderRight: BORDER }}>
          <CustomInput
            input={<CustomInput.Text />}
            name="overview.name"
            choices={mapProjectSize}
            type="email"
            placeholder="Add company name"
            label="company name"
            required
          />

          <CustomInput
            input={<CustomInput.Text />}
            name="overview.url"
            choices={mapProjectSize}
            type="email"
            placeholder="Add company url"
            label="company website"
            required
          />
        </Stack>

        <Stack spacing={3} flex={1} sx={{ padding: '0 0 0 24px' }}>
          <BaseInputLabel
            text="headquarters location"
            sx={{
              padding: '0 0 12px 0',
              margin: '0 0 24px 0',
              borderBottom: BORDER,
              mb: '0px !important',
            }}
          />

          <CustomInput
            input={<CustomInput.Autocomplete />}
            name="overview.headquartersLocation.country"
            choices={mapCountry}
            translation={{ t, ns: 'enum' }}
            placeholder="Select country"
            label="headquarters location"
            required
          />

          <CustomInput
            input={<CustomInput.Text />}
            name="overview.headquartersLocation.city"
            choices={mapCountry}
            translation={{ t, ns: 'enum' }}
            placeholder="Add city"
            label="city"
            required
          />
        </Stack>
      </Stack>

      <ControlledTextEditor
        label="company description"
        name="overview.description"
        items={TimedProjectEditorMenu}
        required
      />
      <BaseInputLabel text="account administrator" />
      <Stack flexDirection="row" mt={1}>
        <Stack
          width="100%"
          pr={3}
          sx={{ borderRight: '1px solid', borderColor: 'secondaryBlue.100' }}
        >
          <ControlledTextInput
            name="admin.email"
            placeholder={user?.email}
            label="User email"
            disabled
          />
        </Stack>

        <Stack width="100%" pl={3}>
          <CustomInput
            input={<CustomInput.Text />}
            name="admin.jobTitle"
            placeholder="Enter job title"
            label="Job title"
            required
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Overview;
